import React from 'react';
import { BookOpen, ArrowLeftRight, Users, ShoppingBag, User as UserIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
import type { TabKey } from './Tabs';

interface Props {
  active: TabKey;
  onChange: (key: TabKey) => void;
  badge?: Partial<Record<TabKey, number>>;
}

const TABS: { key: TabKey; label: string; icon: LucideIcon }[] = [
  { key: 'album', label: 'Álbum', icon: BookOpen },
  { key: 'trocas', label: 'Trocas', icon: ArrowLeftRight },
  { key: 'amigos', label: 'Amigos', icon: Users },
  { key: 'parceiros', label: 'Parceiros', icon: ShoppingBag },
  { key: 'perfil', label: 'Perfil', icon: UserIcon },
];

export function BottomNav({ active, onChange, badge }: Props) {
  return (
    <nav
      className="md:hidden fixed bottom-0 inset-x-0 bg-white border-t-[1.5px] border-ink-300 z-50 flex"
      style={{ paddingBottom: 'env(safe-area-inset-bottom, 0px)' }}
    >
      {TABS.map((t) => {
        const Icon = t.icon;
        const isActive = t.key === active;
        const count = badge?.[t.key] ?? 0;
        return (
          <button
            key={t.key}
            type="button"
            onClick={() => onChange(t.key)}
            aria-label={t.label}
            className={[
              'flex-1 relative flex flex-col items-center gap-1 py-2.5 pb-3 btn-focus',
              isActive ? 'text-green-700' : 'text-ink-500',
            ].join(' ')}
          >
            {isActive && (
              <span
                aria-hidden="true"
                className="absolute top-0 left-1/2 -translate-x-1/2 w-8 h-[3px] bg-green-700 rounded-b-md"
              />
            )}
            <span className="relative inline-flex">
              <Icon size={22} strokeWidth={isActive ? 2.5 : 2} />
              {count > 0 && (
                <span className="absolute -top-1 -right-2 min-w-[16px] h-[16px] rounded-full bg-green-700 text-white text-[10px] font-display font-bold inline-flex items-center justify-center px-1 ring-2 ring-white">
                  {count > 9 ? '9+' : count}
                </span>
              )}
            </span>
            <span
              className={[
                'font-body text-[11px]',
                isActive ? 'font-bold' : 'font-medium',
              ].join(' ')}
            >
              {t.label}
            </span>
          </button>
        );
      })}
    </nav>
  );
}
